// @ngInject
function purchasePriceUpdateConfirmationDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(changedRows) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'purchasePriceUpdateConfirmationDialogController as vm',
            templateUrl: 'services/dialogs/purchasePriceUpdateConfirmationDialog/purchasePriceUpdateConfirmationDialog.tpl.html',
            size: 'lg'
        };

        modalDefaults.resolve = {
            changedRows: function() {
                return changedRows;
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function purchasePriceUpdateConfirmationDialogController($uibModalInstance, changedRows) {
    var vm = this;

    vm.changedRows = changedRows;

    vm.closeModal = closeModal;

    function closeModal(shouldUpdatePrices) {
        $uibModalInstance.close(shouldUpdatePrices);
    }
}

angular
    .module('services.dialogs.purchasePriceUpdateConfirmationDialog', [])
    .service('purchasePriceUpdateConfirmationDialogService', purchasePriceUpdateConfirmationDialogService)
    .controller('purchasePriceUpdateConfirmationDialogController', purchasePriceUpdateConfirmationDialogController);
